import type { I18nTranslation } from '@crehana/i18n';

import { en } from './en';
import { es } from './es';
import { pt } from './pt';

const locales: I18nTranslation = {
  en,
  es,
  pt,
};

export * from './types';
export * from './constants';

export default locales;
